import { Box, Container } from '@mui/material';

import { UnderlinedText } from '@/components/UnderlinedText/index.ts';
import { competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';
import useBrainSession from '@/services/BrainSession/useBrainSession.ts';
import { Button } from '@/ui/Button.tsx';

import Page from '../../components/Page/index.ts';

import type { Route } from './+types/CompetitionWinners';
import { CompetitionTile } from './CompetitionTile.tsx';
import { getConfig } from './config.tsx';

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  return { competitions };
}

export default function Component({ loaderData }: Route.ComponentProps) {
  const { toggleChat } = useBrainSession();

  return (
    <Page title="Tidligere Trekninger">
      <Box
        sx={{
          backgroundColor: 'white',
          width: '100%',
          position: 'relative',
          isolation: 'isolate',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            background: 'linear-gradient(180deg, #D1ECFE 0%, rgba(209, 236, 254, 0) 87.5%)',
            height: 440,
            zIndex: -1,
          }}
        />

        <Container maxWidth="xl" sx={{ mt: 10, mb: 16 }}>
          <h1 className="mb-16 text-center typography-v1-display leading-[140%] text-balance">
            Scoopr <UnderlinedText>trekninger</UnderlinedText>
          </h1>

          <h2 className="mb-4 text-center typography-v1-h4">
            Vi vil at enda flere skal få lavere rente på sine kredittkort - og forbrukslån!
          </h2>

          <p className="mx-auto max-w-[85ch] text-center typography-v1-body4">
            Disse trekningene skaper oppmerksomhet rundt det å sjekke gjelden sin. Gjennom å sjekke
            gjelden sin har flere tusen deltakere fått tilbud om lavere rente og muligheten til å
            vinne.
          </p>

          <Box sx={{ my: 12 }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: 'repeat(1, minmax(0, 1fr))',
                  sm: 'repeat(2, minmax(0, 1fr))',
                  md: 'repeat(3, minmax(0, 1fr))',
                  lg: 'repeat(4, minmax(0, 1fr))',
                },
                gap: 2,
              }}
            >
              {loaderData.competitions.map((c, i) => (
                <CompetitionTile
                  key={c.slug}
                  big={i === 0}
                  competition={c}
                  config={getConfig(c.slug)}
                />
              ))}
            </Box>
          </Box>

          <h2 className="mb-10 text-center typography-v1-h1">
            Vi vil at enda flere skal få lavere rente på sine kredittkort- og forbrukslån!
          </h2>

          <Box sx={{ textAlign: 'center' }}>
            <Button
              color="orange"
              onClick={() => {
                toggleChat({ goal: 'debt_check', step: 'skip_start' });
              }}
            >
              Sjekk om du kan få lavere rente
            </Button>
          </Box>
        </Container>
      </Box>
    </Page>
  );
}
